import { Card, Col, Row } from 'react-bootstrap';
import { Key } from 'react';
import coverImage from 'assets/img/generic/cover-factory.png';
import CoverUpload from 'components/common/CoverUpload';
import AvatarUpload from 'components/common/AvatarUpload';
import AuthService from 'services/auth.service';
import UpdateUserForm from 'components/forms/UpdateUserForm';
import { Link } from 'react-router-dom';
import FeatherIcon from 'feather-icons-react';
import avatar1 from 'assets/img/team/150x150/avatarsysadmin.png';
import avatar2 from 'assets/img/team/150x150/avatarsysadminops.png';
import avatar3 from 'assets/img/team/150x150/avatarsysadminqa.png';
import avatar4 from 'assets/img/team/150x150/avatarmemberqa.png';
import avatar5 from 'assets/img/team/150x150/avatarmemberops.png';
import { secureStorage } from 'services/secure-storage.service';

const UserProfile = () => {
  const currentUser = AuthService.getCurrentUser();
  const dateregister = new Date(currentUser.registerat);
  const datelastseen = new Date(currentUser.lastseen);
  const avatar = secureStorage.getItem('avatar');
  const isLocalUser = currentUser.auth_type === 'local';

  let tfarequired = 'No';
  if (currentUser.activation_code) {
    tfarequired = 'Yes';
  }

  const avatarMap: { [key: string]: string } = {
    avatar1,
    avatar2,
    avatar3,
    avatar4,
    avatar5
  };

  const profileImage = avatarMap[avatar ?? ''] || '';

  const getAuthTypeDisplay = (authType: string) => {
    switch (authType) {
      case 'saml-azure':
        return <span className="badge bg-primary">Azure AD Account</span>;
      case 'saml-manageengine':
        return (
          <span className="badge bg-primary">ManageEngine ADS Account</span>
        );
      default:
        return <span className="badge bg-primary">Local Account</span>;
    }
  };

  return (
    <Card className="mb-5">
      <Card.Header
        className="d-flex justify-content-center align-items-end position-relative mb-7 mb-xxl-0"
        style={{ minHeight: '150px' }}
      >
        <CoverUpload src={coverImage} />
        <AvatarUpload
          size="5xl"
          src={profileImage}
          thumbnail={true}
          className="feed-profile"
          imageClassName="border-0"
        />
      </Card.Header>
      <Card.Body>
        <Row>
          <Col>
            <div className="mb-3">
              <h2 className="me-2">
                {currentUser.name} {currentUser.lastname}
              </h2>
              {getAuthTypeDisplay(currentUser.auth_type)}
            </div>
            <div className="mb-5 fs-9">
              Account created on {dateregister.toLocaleString()} <br />
              Your last conection on {datelastseen.toLocaleString()}
            </div>
          </Col>
          {isLocalUser && (
            <Col xs="auto" className="order-xxl-2">
              <Link
                to="/authentication/reset-password"
                className="btn btn-phoenix-secondary d-flex flex-center w-100 fs-10 p-2"
              >
                <FeatherIcon icon="key" className="me-2" size={14} />
                Change your Password
              </Link>
            </Col>
          )}
        </Row>
        <Row className="pb-6">
          <Col>
            <div>
              <div className="mb-2">
                <strong>Id: </strong>
                <br />
                {currentUser.id}
              </div>
              <div className="mb-2">
                <strong>Username: </strong>
                <br />
                {currentUser.username}
              </div>
              <div className="mb-2">
                <strong>Token: </strong>
                <br />
                {currentUser.accessToken.substring(0, 20)} .........
              </div>
              <div className="mb-2">
                <strong>Authentication Type: </strong>
                <br />
                {isLocalUser ? 'Local' : 'SAML'}
              </div>
              {isLocalUser && (
                <div className="mb-2">
                  <strong>TFA required: </strong>
                  <br />
                  {tfarequired}
                </div>
              )}
              <div>
                <strong>Authorities:</strong>
                <br />
                <ul>
                  {currentUser.roles &&
                    currentUser.roles.map((role: string, index: Key) => (
                      <li key={index}>{role}</li>
                    ))}
                </ul>
              </div>
            </div>
          </Col>
          <Col xs="auto" sm={8}>
            <div className="pt-0 pb-3">
              <strong>Personal information</strong>
              {!isLocalUser ? (
                <div className="mt-0 rounded border bg-body p-4 pt-2 pb-3">
                  <div className="mb-1">
                    <label className="form-label text-body-tertiary">
                      First Name
                    </label>
                    <div className="form-control-plaintext border rounded px-2 bg-body-emphasis">
                      {currentUser.name}
                    </div>
                  </div>
                  <div className="mb-1">
                    <label className="form-label text-body-tertiary">
                      Last Name
                    </label>
                    <div className="form-control-plaintext border rounded px-2 bg-body-emphasis">
                      {currentUser.lastname}
                    </div>
                  </div>
                  <div className="mb-4">
                    <label className="form-label text-body-tertiary">
                      Email
                    </label>
                    <div className="form-control-plaintext border rounded px-2 bg-body-emphasis">
                      {currentUser.email}
                    </div>
                  </div>
                  <div className="fs-9 text-primary">
                    <FeatherIcon icon="info" className="me-2" size={14} />
                    This information is managed through your SAML Identity
                    Provider
                  </div>
                </div>
              ) : (
                <UpdateUserForm
                  id={currentUser.id}
                  firstname={currentUser.name}
                  lastname={currentUser.lastname}
                  email={currentUser.email}
                />
              )}
            </div>
          </Col>
        </Row>
      </Card.Body>
    </Card>
  );
};

export default UserProfile;
